export const MOBILE_POPUP_HEIGHT = '80dvh';
